import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form,
    Pagination,
    Row,
    Col,
    Popover,
    Modal,
    message,
    Popconfirm,
    Spin,
    Select,
    Button,
    Icon,
    Table,
    Input,
    InputNumber,
    DatePicker,
    TimePicker,
    Radio,
    Checkbox,
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { dateConversion, stringToTime, getDateBetween, paramsEncode } from '../../../utils';
import Urls from '../../../../config';
import onLineImg from '../../../circleGreen.png';
import offLineImg from '../../../circleRed.png';
import {
    createShowTaskNoteModel,
    getTaskNotes,
    getList,
    getTaskId,
    createAddShowAction,
    createEditShowAction,
    createAddTypeAction,
    submitToMD,
    createParentIdAction,
    createRootAction,
    createTaskAction,
    createEditInfoAction,
    submitOpera,
    createResetPvShowAction,
    createSetTaskIdAction,
    getPv,
    createSetTaskIdListAction,
    createbulkUpdateShowTaskAction,
    bunchOnoffTask,
    pasteSubTask,
    createScreenShowAction,
    createPrintTaskItemData,
    getUserList,
    createApiAction,
    getApiUrl,
    getTasklogs,
    hideModal, createHideTaskNoteModel,editTaskOverflowStatus,getAccountList,
} from './actions';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const RangePicker = DatePicker.RangePicker;
const getDownloadUrl = Urls.TaskUrl.download;

const { TextArea } = Input;
import AddTask from './add';
import ResetPv from './ResetPv';
import BulkUpdateTask from './bulkUpdate';
import ScreenShotFrame from './screenshotFrame';
import ShowApiUrl from './showApi';

import EditTask from './edit';
import EditOverFlow from './editOverflow';
import data from './data';
import TimeLineList from './timeLineList';
import TaskNote from './taskNote';
let role = JSON.parse(localStorage.getItem('HippoUserInfo'))
    ? JSON.parse(localStorage.getItem('HippoUserInfo')).role
    : 0;
let getTree = (data, id) => {
    let tree = {};
    for (var a = 0; a < data.length; a++) {
        let item = data[a];
        if (item.taskId == id) {
            tree = item;
            break;
        }
    }
    return tree;
};

let rootId = 0;

const handlerData = data => {
    if (!data) {
        data = [];
    }
    const newData = data.map((v, k) => {
        return formatData(v);
    });
    return newData;
};
const formatData = item => {
    item.key = item.taskId;

    if (item.parentId == 0) {
        rootId = item.taskId;
    }
    item.rootId = rootId;
    if(item.taskType == 'EV'){
        item.taskTypeName = '曝光';
    }else if(item.taskType == 'CLICK'){
        item.taskTypeName = '点击';
    }else if(item.taskType == 'COMBINE_EV_CLICK'){
        item.taskTypeName= '合并';
    }else if(item.taskType == 'APPLAUNCH'){
        item.taskTypeName= 'APP拉起';
    }else if(item.taskType == 'APP_RETAIN'){
        item.taskTypeName= '注册留存';
    } else if(item.taskType ==  'RE'){
        item.taskTypeName = '注册';
    }
    for (let k in item) {
        if (k == 'action') {
            item[k] = '';
        } else if (k == 'subTasks') {
            let subList = item[k];
            subList.map(subI => {
                let newSubI = formatData(subI);
                return newSubI;
            });
        } else {
            item[k] = item[k] == 'null' ? '' : item[k];
        }
    }
    return item;
};
const searchStatus = [
    {
        id: '3',
        name: '全部',
    },
    {
        id: '0',
        name: '已上线',
    },
    {
        id: '1',
        name: '已下线',
    },
];
let showData = {};

let taskIds = [];
let orderSet = [];

class TaskComponent extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            page: 1, //分页页码
            pageSize: 10, //分页大小
            taskId: undefined, //任务id
            taskName: undefined, //任务名称
            status: '3', //选择状态
            sBeginTime: '', //开始时间
            sEndTime: '', //结束时间
            taskIds: [], //任务Id数组
            defaultTaskDescription: undefined, //订单名称
            downloadUrl: getDownloadUrl,
            taskDescription: '', //查询用订单名称
            taskType: undefined, //任务类型
            taskSource: undefined, //任务来源
            platform: undefined, //投放平台
            time: undefined, //
            ps: undefined,
            adId: undefined,
            principal: undefined,//责任人
        };
        this.changePageSize = this.changePageSize.bind(this);
    }
    componentWillMount=()=>{
        if (window.localStorage.getItem('randoms')) {
            let randoms = window.localStorage.getItem('randoms');
            randoms++;
            window.localStorage.randoms = randoms;
        } else {
            window.localStorage.randoms = 10;
        }
    }

    findData = (data, id) => {
        for (let j = 0; j < data.length; j++) {
            let item = data[j];
            if (item.taskId == id) {
                showData = item;
                break;
            } else {
                this.findData(item.subTasks, id);
            }
        }
        return showData;
    };
    removeSubTask = (data, id) => {
        let subTask = data.subTasks;
        if (subTask != undefined && subTask != null && subTask.length > 0) {
            for (var a = 0; a < subTask.length; a++) {
                if (subTask[a].taskId == id) {
                    subTask.splice(a, 1);
                    break;
                } else {
                    this.removeSubTask(subTask[a], id);
                }
            }
        }
    };
    getFirstTaskDescription = list => {
        let defaultTaskDescription = list.slice(0, 1)[0].taskDescription;
        this.setState({
            ...this.state,
            defaultTaskDescription: defaultTaskDescription,
        });
        return list.slice(0, 1);
    };
    componentDidMount() {
        this.props.getList(this.state);
        this.props.getUserList();
        this.props.getAccountList();
    }
    async removeItem(id, type) {
        // 删除
        await this.props.opera(id, type);
        await this.props.getList(this.state);
    }
    // async reset(id) {
    //   console.log(id);
    //     // 重置
    //     await this.props.resetPv(id);
    //     await this.props.getList(this.state);
    // }
    async changeAddShow(param, id, rootId) {
        this.props.setAddType(param);

        if (id) {
            await this.props.getTaskId();
            this.props.storeParentId(id);
            let tree = getTree(this.props.taskList, rootId);
            this.props.storeRoot(tree);
        }
        this.props.changeAddStatus(true);
        this.getFirstTaskDescription(this.props.taskList);
    }
    async changeEditShow(id, rootId) {
        let tree = getTree(this.props.taskList, rootId);
        this.props.storeRoot(tree);
        let showInfo = this.findData(this.props.taskList, id);
        this.props.storeEditInfo(showInfo);
        this.props.changeEditStatus(true);
    }
    async deleteSubTask(id, rootId) {
        let tree = getTree(this.props.taskList, rootId);
        this.removeSubTask(tree, id);
        this.props
            .toSubmit(tree)
            .then(() => {
                this.props.getList(this.state);
                message.success('删除子任务成功!!!');
            })
            .catch(e => {
                message.error('删除子任务失败!!!');
            });
    }
    async copyTask(rootId) {
        let tree = getTree(this.props.taskList, rootId);
        if (tree.subTasks == null || tree.subTasks == undefined || tree.subTasks.length == 0) {
            message.error('请选择有子任务的任务!!!');
            return;
        }
        this.props.storeTask(tree);
    }

    async toGetTasklogs(id){
        let tree = getTree(this.props.taskList, id);
        console.log('id', id);
        // let taskId = {taskId: '559136981'}
        let taskId = {taskId: id}
        if(id){
            await this.props.getTasklogs(taskId);
        }
    }

    async getTaskNote(eId){
        if(eId==undefined || eId==""){
           //this.props.modalShow();
            message.error("广告id不能为空!");
            return ;
        }
        this.props.getTaskNotes({"eId":eId});
    }

    changePv(id) {
        this.props.setTaskId(id);
        let temp = true;
        this.props
            .getTargetPv(id)
            .then(() => {
                this.props.ResetPvStatus(temp);
            })
            .catch(e => {
                temp = false;
                this.props.ResetPvStatus(temp);
            });
    }
    onoffTask(value) {
        if (this.state.taskIds === undefined || this.state.taskIds.length == 0) {
            message.error('请先勾选再进行批量上下线操作!!!');
            return;
        }
        this.props
            .bunchOnoffTask(this.state.taskIds, value)
            .then(() => {
                if (value == 1) {
                    message.success('批量下线成功!!!');
                } else if (value == 0) {
                    message.success('批量上线成功!!!');
                } else if (value == -1) {
                    message.success('批量删除成功!!!');
                }
                this.props.getList(this.state);
            })
            .catch(e => {
                if (value == 1) {
                    message.error('批量下线失败!!!');
                } else if (value == 0) {
                    message.error('批量上线失败!!!');
                } else if (value == -1) {
                    message.error('批量删除失败!!!');
                }
            });
    }

    pasteSubTask() {
        if (this.state.taskIds === undefined || this.state.taskIds.length == 0) {
            message.error('请先勾选再进行子任务粘贴操作!!!');
            return;
        }
        if (this.props.Task === undefined || !this.props.Task.taskId) {
            message.error('请先复制任务再进行子任务粘贴操作!!!');
            return;
        }
        this.props
            .pasteSubTask(this.state.taskIds, this.props.Task)
            .then(() => {
                this.props.storeTask({});
                this.props.getList(this.state);
                message.success('粘贴操作成功!!!');
            })
            .catch(e => {
                message.error('粘贴操作失败!!!');
            });
    }

    bulkUpdateTask() {
        if (orderSet.size === undefined || orderSet.size == 0) {
            message.error('请先勾选再进行批量操作!!!');
            return;
        }
        if (orderSet.size > 1) {
            message.error('勾选有' + orderSet.size + '种类型订单!!!');
        }
        this.props.setTaskList(this.state.taskIds);
        this.props.ResetBulkUpdateStatus(true);
    }
    // 改变当前页
    async changePageSize(pageNumber, pageSize) {
        await this.setState({
            page: pageNumber,
            pageSize: pageSize,
            taskIds: [],
        });
        orderSet = new Set();
        await this.props.setTaskList([]);
        await this.props.getList(this.state);
    }
    async randomOverFlow(){
       this.props.editTaskOverflowStatus(true);
    }
    async changeState() {
        await this.setState({
            taskId: undefined, //任务id
            taskName: undefined, //任务名称
            status: '3', //选择状态
            sBeginTime: '', //开始时间
            sEndTime: '', //结束时间
            taskIds: [], //任务Id数组
            defaultTaskDescription: undefined, //订单名称
            downloadUrl: getDownloadUrl,
            taskDescription: undefined, //查询用订单名称
            taskType: undefined, //任务类型
            taskSource: undefined, //任务来源
            platform: undefined, //投放平台
            time: undefined, //
            ps: undefined,
            adId: undefined,
            principal: undefined
        });
    }

    async searchBegin() {
        await this.setState({
            ...this.state,
            page: 1,
            taskIds: [],
        });
        // const search={...this.state,page: 1};
        // debugger
        orderSet = new Set();
        this.props.getList(this.state);
    }
    async changeId(id) {
        let paramStr = '';
        const param = {
            taskId: id.target.value, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            taskId: id.target.value,
            downloadUrl: paramStr,
        });
    }
    async changeName(name) {
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: name.target.value, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            taskName: name.target.value,
            downloadUrl: paramStr,
        });
    }
    async changeTaskDescription(taskDescription) {
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: taskDescription.target.value, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            taskDescription: taskDescription.target.value,
            downloadUrl: paramStr,
        });
    }
    async changeAdId(adId) {
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: adId.target.value,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            adId: adId.target.value,
            downloadUrl: paramStr,
        });
    }
    async changePs(ps) {
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: ps.target.value,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            ps: ps.target.value,
            downloadUrl: paramStr,
        });
    }
    async changeStatus(status) {
        // debugger
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            status: status,
            downloadUrl: paramStr,
        });
    }
    async changeTaskType(taskType) {
        // debugger
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            taskType: taskType,
            downloadUrl: paramStr,
        });
    }
    async changePlatform(platform) {
        // debugger
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            platform: platform,
            taskSource: this.state.taskSource,
            taskType: this.state.taskType,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            platform: platform,
            downloadUrl: paramStr,
        });
    }
    async changeTaskSource(taskSource) {
        // debugger
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskSource: taskSource,
            taskType: this.state.taskType,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            taskSource: taskSource,
            downloadUrl: paramStr,
        });
    }
    async changeTime(time) {
        // debugger
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskSource: this.state.taskSource,
            taskType: this.state.taskType,
            platform: this.state.platform,
            time: time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            time: time,
            downloadUrl: paramStr,
        });
    }
    async changeData(a, b) {
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: b[0], //开始时间
            sEndTime: b[1], //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            sBeginTime: b[0],
            sEndTime: b[1],
            downloadUrl: paramStr,
        });
    }

    async changePrincipal(a) {
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: this.state.taskIds, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: a,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            principal: a,
            downloadUrl: paramStr,
        });
    }

    async changeTaskIds(b) {
        let paramStr = '';
        const param = {
            taskId: this.state.taskId, //任务id
            taskName: this.state.taskName, //任务名称
            status: this.state.status, //选择状态
            sBeginTime: this.state.sBeginTime, //开始时间
            sEndTime: this.state.sEndTime, //结束时间
            taskIds: b, //任务Id数组
            taskDescription: this.state.taskDescription, //订单名称
            taskType: this.state.taskType,
            taskSource: this.state.taskSource,
            platform: this.state.platform,
            time: this.state.time,
            ps: this.state.ps,
            adId: this.state.adId,
            principal: this.state.principal,
        };
        paramStr = getDownloadUrl + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            ...this.state,
            taskIds: b,
            downloadUrl: paramStr,
        });
    }
    // 截图弹框控制
    showScreenFrame(record) {
        if (window.localStorage.getItem('randoms')) {
            let randoms = window.localStorage.getItem('randoms');
            randoms++;
            window.localStorage.randoms = randoms;
        } else {
            window.localStorage.randoms = 10;
        }
        this.props.savePrintTaskItemData(record);
        this.props.changeScreenShotStatus(true);
    }

    showApiUrl(record) {
        const {taskId} = record;
        this.props.changeStatus({taskId, isShowApi: true});
    }

    handleOk = (e) => {
        // console.log(e);
        //this.setState({
        //    visible: false,
        //});
        this.props.hideModal();
    }

    handleCancel = (e) => {
        // console.log(e);
        // this.setState({
        //     visible: false,
        // });
        this.props.hideModal();
    }


    render() {
        const { taskList, ListLoading, pageTotal, pvCount, Root, Task,userList } = this.props;
        const selectedRowKeys = this.state.taskIds;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {},
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
            }),
            onSelect: (record, selected, selectedRows) => {
                const Ids = selectedRows.map(item => item.taskId);
                const orders = selectedRows.map(item => item.taskDescription);
                this.changeTaskIds(Ids);
                orderSet = new Set(orders);
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                if (selected == true) {
                    const Ids = selectedRows.map(item => item.taskId);
                    const orders = selectedRows.map(item => item.taskDescription);
                    this.changeTaskIds(Ids);
                    orderSet = new Set(orders);
                } else if (selected == false) {
                    const Ids = [];
                    const orders = [];
                    this.changeTaskIds(Ids);
                    orderSet = new Set(orders);
                }
            },
        };

        const columns = [
            {
                title: '任务ID',
                dataIndex: 'taskId',
            },
            {
                title: '订单名称',
                dataIndex: 'taskDescription',
            },
            {
                title: '名称',
                dataIndex: 'taskName',
            },
            {
                title: '广告ID',
                dataIndex: 'adid',
                render: (text, record) => (
                    <span>
                        {text}
                        {record.eId == text ? '' : '/' + record.eId}
                    </span>
                ),
            },
            {
                title: 'PS',
                dataIndex: 'ps',
            },
            {
                title: '任务类型',
                dataIndex: 'taskTypeName',
            },
            {
                title: 'URL',
                dataIndex: 'url',
                render: (text, record) => (
                    <div>
                        <Popover content={record.url} title="URL">
                            <a href={record.url} target="_blank">
                                点击跳转
                            </a>
                        </Popover>
                    </div>
                ),
            },
            // {
            //     title: '描述',
            //     dataIndex: 'taskDescription',
            // },
            {
                title: '目标量/溢出量',
                dataIndex: 'targetPv',
                render: (text, record) => (
                    <span>
                        {record.targetPv}/{record.overflow}
                    </span>
                ),
            },
            // {
            //     title: 'UV占比',
            //     dataIndex: 'pvToUvRatio',
            // },
            // {
            //     title: '开始时间',
            //     dataIndex: 'beginDateStr',
            // }, {
            //     title: '结束时间',
            //     dataIndex: 'endDateStr',
            // },
            {
                title: '平台',
                dataIndex: 'platform',
            },
            {
                title: '启用时间',
                dataIndex: 'filtration',
                // render: (text, record) => (
                //     <div>
                //         {record.filtration ? record.filtration.map((v, k) => {
                //             return <p>{v}</p>
                //         }) : ''}
                //     </div>
                // )
                render: (times, record) => {
                    let content = (
                        <div>
                            {times
                                ? times.map((v, k) => {
                                      return <p>{v}</p>;
                                  })
                                : ''}
                        </div>
                    );
                    return (
                        <div>
                            {times
                                ? times
                                      .filter((item, index) => {
                                          return index < 2;
                                      })
                                      .map((v, k) => {
                                          return <p>{v}</p>;
                                      })
                                : ''}
                            {times && times.length > 2 ? (
                                <Popover content={content} title="启用时间">
                                    <a type="primary">...</a>
                                </Popover>
                            ) : (
                                ''
                            )}
                        </div>
                    );
                },
            },
            {
                title: '时间段',
                dataIndex: 'timePairs',
                render: (times1, record) => {
                    let content = (
                        <div>
                            {times1
                                ? times1.map((v, k) => {
                                      console.log("haha1");
                                      return ( 
                                        <div><span>{stringToTime(v.beginTime)}</span>-
                                         <span>{stringToTime(v.endTime)}</span>
                                         </div>
                                       )
                                  })
                                : ''}
                        </div>
                    );
                    return (
                        <div>
                            {times1
                                ? times1
                                      .filter((item, index) => {
                                          return index < 2;
                                      })
                                      .map((v, k) => {
                                        //   return <p>{v}</p>;
                                         return ( 
                                                <div><span>{stringToTime(v.beginTime)}</span>-
                                                 <span>{stringToTime(v.endTime)}</span>
                                                 </div>
                                         )
                                      })
                                : ''}
                            {times1 && times1.length > 2 ? (
                                <Popover content={content} title="时间段">
                                    <a type="primary">...</a>
                                </Popover>
                            ) : (
                                ''
                            )}
                        </div>
                    );
                },
            },
            //因只能展示第一个时间段 则要废弃
            // {
            //     title: '时间段',
            //     dataIndex: 'timePairs',
            //     render: (text, record) => (
            //         <span>
            //             <span>{stringToTime(record.timePairs[0].beginTime)}</span>-
            //             <span>{stringToTime(record.timePairs[0].endTime)}</span>
            //         </span>
            //     ),
            // },
            {
                title: '创建时间',
                dataIndex: 'createTimeStr',
            },
            // {
            //     title: '利用次数',
            //     dataIndex: 'ipReusedTimes',
            // },
            {
                title: '创建者',
                dataIndex: 'creator',
                render: (text, record) => (
                    <span>
                        {' '}
                        {(record.eId == '' || record.eId === undefined) ? '(本系统)' :  record.eId.substring(0,1)=='h' ? '(流量系统)' : '(广告系统)'}
                        {record.creator}
                    </span>
                ),
            },
            {
                title: '状态',
                dataIndex: 'status',
                render: (text, record) => (
                    <span>{record.status == 0 ? <img src={onLineImg} /> : <img src={offLineImg} />}</span>
                ),
            },
            {
                title: '操作',
                dataIndex: 'actions',
                render: (text, record) => (
                    <div>
                        {role == 1 ? (
                            <div>
                                <Link
                                    to={`/statistics/task/${record.taskId},${this.state.sBeginTime},${
                                        this.state.sEndTime
                                    }`}>
                                    统计
                                </Link>
                                <span className="ant-divider" />
                                <a
                                    href="javascript:;"
                                    onClick={() => this.changeEditShow(record.taskId, record.rootId)}>
                                    编辑
                                </a>
                                <span className="ant-divider" />
                                <a
                                    href="javascript:;"
                                    onClick={() => this.changeAddShow(2, record.taskId, record.rootId)}>
                                    添加子任务
                                </a>
                                <span className="ant-divider" />
                                <a href="javascript:;" onClick={() => this.copyTask(record.taskId, record.rootId)}>
                                    复制
                                </a>
                            </div>
                        ) : (
                            <div>
                                <Link to={`/statistics/task/${record.taskId}`}>统计</Link>
                                <span className="ant-divider" />
                                <a
                                    href="javascript:;"
                                    onClick={() => this.changeEditShow(record.taskId, record.rootId)}>
                                    编辑
                                </a>
                            </div>
                        )}

                        <div>
                            <Popconfirm
                                title="确定删除？"
                                onConfirm={() => this.removeItem(record.taskId, -1)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="task_remove">
                                <a href="javascript:;">删除</a>
                            </Popconfirm>
                            <span className="ant-divider" />

                            <Popconfirm
                                title="确定上线？"
                                onConfirm={() => this.removeItem(record.taskId, 0)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="task_remove">
                                <a href="javascript:;">上线</a>
                            </Popconfirm>
                            <span className="ant-divider" />
                            <Popconfirm
                                title="确定下线？"
                                onConfirm={() => this.removeItem(record.taskId, 1)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="task_remove">
                                <a href="javascript:;">下线</a>
                            </Popconfirm>
                            <span className="ant-divider" />
                            {/* <Popconfirm
                                title="确定重置？"
                                onConfirm={() => this.reset(record.taskId)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="task_remove">
                                <a href="javascript:;">重置</a>
                            </Popconfirm> */}
                            <a href="javascript:;" onClick={() => this.changePv(record.taskId)}>
                                重置
                            </a>
                            <span className="ant-divider" />
                            <a href="javascript:;" onClick={() => this.showScreenFrame(record)}>
                                截图
                            </a>
                            <span className="ant-divider" />
                            <a href="javascript:;" onClick={() => this.showApiUrl(record)}>
                                api
                            </a>
                            <span className="ant-divider" />
                            <a href="javascript:;" onClick={() => this.toGetTasklogs(record.taskId)}>
                                时间线
                            </a>
                            <span className="ant-divider" />
                            <a href="javascript:;" onClick={() => this.getTaskNote(record.eId)}>
                                备注
                            </a>
                        </div>
                    </div>
                ),
            },
        ];

        const expandedRowRender = (dataJson, topId) => {
            let record = dataJson.subTasks;
            if (record.length) {
                let cols = [
                    {
                        title: '子任务ID',
                        dataIndex: 'taskId',
                    },
                    {
                        title: '订单名称',
                        dataIndex: 'taskDescription',
                    },
                    {
                        title: '名称',
                        dataIndex: 'taskName',
                    },
                    {
                        title: '任务类型',
                        dataIndex: 'taskTypeName',
                    },
                    {
                        title: 'URL',
                        dataIndex: 'url',
                        render: (text, record) => (
                            <div>
                                <Popover content={record.url} title="URL">
                                    <a href={record.url} target="_blank">
                                        点击跳转
                                    </a>
                                </Popover>
                            </div>
                        ),
                    },
                    // {
                    //     title: '描述',
                    //     dataIndex: 'taskDescription',
                    // },
                    {
                        title: '目标量/溢出量',
                        dataIndex: 'targetPv',
                        render: (text, record) => (
                            <span>
                                {record.targetPv}/{record.overflow}
                            </span>
                        ),
                    },
                    // {
                    //     title: 'UV占比',
                    //     dataIndex: 'pvToUvRatio',
                    // },
                    // {
                    //     title: '开始时间',
                    //     dataIndex: 'beginDateStr',
                    // }, {
                    //     title: '结束时间',
                    //     dataIndex: 'endDateStr',
                    // },
                    {
                        title: '平台',
                        dataIndex: 'platform',
                    },
                    {
                        title: '启用时间',
                        dataIndex: 'filtration',
                        render: (times, record) => {
                            let content = (
                                <div>
                                    {times
                                        ? times.map((v, k) => {
                                              return <p>{v}</p>;
                                          })
                                        : ''}
                                </div>
                            );
                            return (
                                <div>
                                    {times
                                        ? times
                                              .filter((item, index) => {
                                                  return index < 2;
                                              })
                                              .map((v, k) => {
                                                  return <p>{v}</p>;
                                              })
                                        : ''}
                                    {times && times.length > 2 ? (
                                        <Popover content={content} title="启用时间">
                                            <a type="primary">...</a>
                                        </Popover>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            );
                        },
                    },
                    {
                        title: '时间段',
                        dataIndex: 'timePairs',
                        render: (text, record) => (
                            <span>
                                <span>{stringToTime(record.timePairs[0].beginTime)}</span>-
                                <span>{stringToTime(record.timePairs[0].endTime)}</span>
                            </span>
                        ),
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'createTimeStr',
                    },
                    {
                        title: '创建者',
                        dataIndex: 'creator',
                        render: (text, record) => (
                            <span>
                                {' '}
                                {(record.eId == '' || record.eId === undefined) ? '(本系统)' :  record.eId.substring(0,1)=='h' ? '(流量系统)' : '(广告系统)'}
                                {record.creator}
                            </span>
                        ),
                    },
                    // {
                    //     title: '利用次数',
                    //     dataIndex: 'ipReusedTimes',
                    // },
                    // {
                    //     title: '状态',
                    //     dataIndex: 'status',
                    // },
                    {
                        title: '操作',
                        dataIndex: 'actions',
                        render: (text, record) => (
                            <span>
                                <Link to={`/statistics/task/${record.taskId}`}>统计</Link>
                                <span className="ant-divider" />
                                <a
                                    href="javascript:;"
                                    onClick={() => this.changeEditShow(record.taskId, record.rootId)}>
                                    编辑
                                </a>
                                <span className="ant-divider" />
                                <Popconfirm
                                    title="确定删除？"
                                    onConfirm={() => this.deleteSubTask(record.taskId, record.rootId)}
                                    onCancel={this.cancel}
                                    okText="确定"
                                    cancelText="取消"
                                    className="task_remove">
                                    <a href="javascript:;">删除</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                                <a
                                    href="javascript:;"
                                    onClick={() => this.changeAddShow(2, record.taskId, record.rootId)}>
                                    添加子任务
                                </a>
                            </span>
                        ),
                    },
                ];
                return (
                    <Table
                        columns={cols}
                        dataSource={record}
                        pagination={false}
                        expandedRowRender={record => expandedRowRender(record, topId)}
                    />
                );
            } else {
                return <span>没有子任务</span>;
            }
        };
        return (
            <div>
                <TaskNote/>
                <Modal
                    width={800}
                    title="时间线"
                    visible={this.props.showTasklogs}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    {this.props.taskLogsList.length > 0 && <TimeLineList/>}
                    {this.props.taskLogsList.length == 0 && <div>暂无时间线数据</div>}

                </Modal>

                <h2 style={{ marginBottom: '20px' }}>任务列表</h2>
                <ShowApiUrl />
                <AddTask listState={this.state} />
                <EditTask listState={this.state} />
                <EditOverFlow searchBegin = {this.searchBegin.bind(this)}/>
                <BulkUpdateTask listState={this.state} />
                <ResetPv />
                {/* 添加截图弹框 */}
                <ScreenShotFrame
                    isShowScreenShot={this.props.isShowScreenFrame}
                    itemRecord={this.props.printTaskData}
                    startTimes={this.state.sBeginTime == '' ? moment().format('YYYY-MM-DD') : this.state.sBeginTime}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <label>
                        任务ID：
                        <Input
                            placeholder="任务id"
                            style={{ width: 50 }}
                            value={this.state.taskId}
                            onChange={this.changeId.bind(this)}
                        />
                    </label>
                    <label>
                        订单名称：
                        <Input
                            placeholder="订单名称"
                            style={{ width: 100 }}
                            value={this.state.taskDescription}
                            onChange={this.changeTaskDescription.bind(this)}
                        />
                    </label>
                    <label>
                        任务名称：
                        <Input
                            placeholder="任务名称"
                            style={{ width: 60 }}
                            value={this.state.taskName}
                            onChange={this.changeName.bind(this)}
                        />
                    </label>
                    <label>
                        选择状态：
                        <Select
                            defaultValue={this.state.status}
                            value={this.state.status}
                            style={{ width: 60 }}
                            onChange={this.changeStatus.bind(this)}>
                            {searchStatus.map(v => <Option value={v.id}>{v.name}</Option>)}
                        </Select>
                    </label>
                    <label>
                        日期：
                        <RangePicker
                            format="YYYY-MM-DD"
                            style={{ width: 160 }}
                            value={
                                this.state.sBeginTime == '' || this.state.sEndTime == ''
                                    ? []
                                    : [
                                          moment(this.state.sBeginTime, 'YYYY-MM-DD'),
                                          moment(this.state.sEndTime, 'YYYY-MM-DD'),
                                      ]
                            }
                            onChange={(value, dateString) => this.changeData(value, dateString)}
                        />
                    </label>
                    <label>
                        任务类型：
                        <Select
                            allowClear
                            placeholder="全部"
                            defaultValue={this.state.taskType}
                            value={this.state.taskType}
                            style={{ width: 64 }}
                            onChange={this.changeTaskType.bind(this)}>
                            <Option value="EV">曝光</Option>
                            <Option value="CLICK">点击</Option>
                            <Option value="APPLAUNCH">APP拉起</Option>
                            <Option value='COMBINE_EV_CLICK'>合并</Option>
                            <Option value='APP_RETAIN'>注册留存</Option>
                            <Option value='RE'>注册</Option>
                        </Select>
                    </label>

                    <label>
                        投放平台：
                        <Select
                            allowClear
                            placeholder="全部"
                            defaultValue={this.state.platform}
                            value={this.state.platform}
                            style={{ width: 60 }}
                            onChange={this.changePlatform.bind(this)}>
                            <Option value="APP">APP</Option>
                            <Option value="WAP">WAP</Option>
                            <Option value="PC">PC</Option>
                            <Option value="OTT">OTT</Option>
                            <Option value="PAD">PAD</Option>
                        </Select>
                    </label>
                    <label>
                        任务来源：
                        <Select
                            allowClear
                            placeholder="全部"
                            defaultValue={this.state.taskSource}
                            value={this.state.taskSource}
                            style={{ width: 60 }}
                            onChange={this.changeTaskSource.bind(this)}>
                            <Option value={'ifengad'}>IFENGAD</Option>
                            <Option value={'dmp'}>DMP</Option>
                            <Option value={'api'}>API</Option>
                            <Option value={'dol'}>传漾</Option>
                            <Option value={'accurateOperations'}>精准运营</Option>
                            <Option value={'lookalike'}>追投</Option>
                            <Option value={'js'}>脚本投放</Option>
                            <Option value={'brandDsp'}>brandDsp</Option>
                        </Select>
                    </label>
                    <label>
                        时间：
                        <Select
                            allowClear
                            placeholder="全部"
                            defaultValue={this.state.time}
                            value={this.state.time}
                            style={{ width: 60 }}
                            onChange={this.changeTime.bind(this)}>
                            <Option value={1}>9点前</Option>
                            <Option value={2}>9点后</Option>
                            <Option value={3}>全天</Option>
                            <Option value={4}>9点后及全天</Option>
                        </Select>
                    </label>
                    <label>
                        adId：
                        <Input
                            placeholder="广告Id"
                            value={this.state.adId}
                            style={{ width: 60 }}
                            onChange={this.changeAdId.bind(this)}
                        />
                    </label>
                    <label>
                        Ps：
                        <Input
                            placeholder="广告位Id"
                            value={this.state.ps}
                            style={{ width: 60 }}
                            onChange={this.changePs.bind(this)}
                        />
                    </label>
                    <label>
                        责任人：
                        <Select allowClear placeholder="全部" onChange={this.changePrincipal.bind(this)} style={{ width: 70 }}>
                            {userList.map((item, index) => {
                                return (
                                    <Option key={index} value={item.name}>
                                        {item.name}
                                    </Option>
                                );
                            })}
                        </Select>
                    </label>
                </div>
                <Row >
                    {pageTotal > 0 ? (
                        <Col  style={{ float:'left' }}>
                            <Pagination
                                showQuickJumper
                                showSizeChanger
                                pageSizeOptions={['10', '20', '30', '40', '50', '60', '70', '80', '90', '100']}
                                onChange={this.changePageSize}
                                onShowSizeChange={this.changePageSize}
                                className="ant-table-pagination"
                                pageSize={this.state.pageSize}
                                defaultPageSize={this.state.pageSize}
                                current={this.state.page}
                                total={pageTotal}
                            />
                        </Col>
                    ) : null}
                    <Col style={{ float:'right' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <Button type="primary" onClick={this.searchBegin.bind(this)}>
                                搜索
                            </Button>
                            <Button type="primary" style={{ float: 'right' }} onClick={() => this.changeAddShow(1)}>
                                添加任务
                            </Button>
                            <Button type="primary" style={{ float: 'right' }} onClick={() => this.bulkUpdateTask()}>
                                批量更新
                            </Button>
                            <Popconfirm
                                title="确定批量上线？"
                                onConfirm={() => this.onoffTask(0)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_on">
                                <Button type="primary" style={{ float: 'right' }}>
                                    批量上线
                                </Button>
                            </Popconfirm>

                            <Popconfirm
                                title="确定批量下线？"
                                onConfirm={() => this.onoffTask(1)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_off">
                                <Button type="primary" style={{ float: 'right' }}>
                                    批量下线
                                </Button>
                            </Popconfirm>
                            <Popconfirm
                                title="确定批量删除？"
                                onConfirm={() => this.onoffTask(-1)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_off">
                                <Button type="primary" style={{ float: 'right' }}>
                                    批量删除
                                </Button>
                            </Popconfirm>
                            <Popconfirm
                                title="确定粘贴子任务？"
                                onConfirm={() => this.pasteSubTask()}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="paste_subTask">
                                <Button type="primary" style={{ float: 'right' }}>
                                    粘贴子任务
                                </Button>
                            </Popconfirm>
                            {/* <Button type="primary" style={{ float: 'right' }} onClick={() => this.onoffTask(1)}>
                          批量下线
                      </Button> */}
                            <Button type="primary" style={{ float: 'right' }}>
                                {/* <Icon type="download" /> */}
                                <a href={this.state.downloadUrl} download="filename">
                                    下载报表
                                </a>
                            </Button>
                            <Button type="primary" onClick={this.randomOverFlow.bind(this)}>
                                整单编辑
                            </Button>
                            <Button type="primary" onClick={this.changeState.bind(this)}>
                                重置
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Spin spinning={ListLoading}>
                    {role == 1 ? (
                        <Table
                            columns={columns}
                            dataSource={handlerData(taskList)}
                            bordered
                            rowSelection={rowSelection}
                            expandedRowRender={record => expandedRowRender(record, record.taskId)}
                            pagination={false}
                        />
                    ) : (
                        <Table
                            columns={columns}
                            dataSource={handlerData(taskList)}
                            bordered
                            pagination={false}
                            rowSelection={rowSelection}
                        />
                    )}
                </Spin>
                {pageTotal > 0 ? (
                    <Row>
                        <Col>
                            <Pagination
                                showQuickJumper
                                showSizeChanger
                                pageSizeOptions={['10', '20', '30', '40', '50', '60', '70', '80', '90', '100']}
                                onChange={this.changePageSize}
                                onShowSizeChange={this.changePageSize}
                                className="ant-table-pagination"
                                pageSize={this.state.pageSize}
                                defaultPageSize={this.state.pageSize}
                                current={this.state.page}
                                total={pageTotal}
                            />
                        </Col>
                    </Row>
                ) : null}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    ListLoading: state.tasklist.ListStatus.loading,
    taskList: state.tasklist.List,
    taskId: state.tasklist.TaskId,
    pageTotal: state.tasklist.ListStatus.pageTotal, // 页码总数
    pvCount: state.tasklist.pvCount, // pv数
    Root: state.tasklist.Root,
    Task: state.tasklist.Task, // 当前复制的任务
    isShowScreenFrame: state.tasklist.screenShow.isShowScreen,
    printTaskData: state.tasklist.printTaskData,
    userList: state.tasklist.UserList, // 用户列表
    showTasklogs: state.tasklist.tasklogs.showModal,
    taskLogsList: state.tasklist.tasklogs.list,
});

const mapDispatchToProps = dispatch => ({
    getList: param => dispatch(getList(param)),
    getTaskId: () => dispatch(getTaskId()),
    changeAddStatus: status => dispatch(createAddShowAction(status)),
    changeEditStatus: status => dispatch(createEditShowAction(status)),
    ResetPvStatus: status => dispatch(createResetPvShowAction(status)),
    setAddType: type => dispatch(createAddTypeAction(type)),
    storeParentId: id => dispatch(createParentIdAction(id)),
    storeRoot: param => dispatch(createRootAction(param)),
    storeTask: param => dispatch(createTaskAction(param)),
    pasteSubTask: (list, task) => dispatch(pasteSubTask(list, task)),
    storeEditInfo: param => dispatch(createEditInfoAction(param)),
    toSubmit: param => dispatch(submitToMD(param)),
    opera: (id, type) => dispatch(submitOpera(id, type)),
    bunchOnoffTask: (ids, type) => dispatch(bunchOnoffTask(ids, type)),
    setTaskId: id => dispatch(createSetTaskIdAction(id)),
    getTargetPv: id => dispatch(getPv(id)),
    setTaskList: list => dispatch(createSetTaskIdListAction(list)),
    ResetBulkUpdateStatus: status => dispatch(createbulkUpdateShowTaskAction(status)),
    changeScreenShotStatus: status => dispatch(createScreenShowAction(status)),
    savePrintTaskItemData: param => dispatch(createPrintTaskItemData(param)),
    getUserList: () => dispatch(getUserList()),
    changeStatus: status => dispatch(createApiAction(status)),
    getApiUrl: param => dispatch(getApiUrl(param)),
    getTasklogs: data => dispatch(getTasklogs(data)),
    hideModal: () => dispatch(hideModal()),
    getTaskNotes: (eId) =>  dispatch(getTaskNotes(eId)),
    modalShow: () => dispatch(createShowTaskNoteModel({ showTaskNoteModel: true })),
    editTaskOverflowStatus: status => dispatch(editTaskOverflowStatus(status)),
    getAccountList: () => dispatch(getAccountList()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TaskComponent);



// WEBPACK FOOTER //
// ./pages/task/tasklist/index.js